import { IManagementAPISendEmailRequest } from '../../../types/management-api/policy/sendEmail/request';

interface ITransformSendEmailRequest {
  certificateId: number;
  emailAddresses?: string[];
}

export const transformSendEmailRequest = ({
  certificateId,
  emailAddresses = []
}: ITransformSendEmailRequest): IManagementAPISendEmailRequest => {  
  return {
    certificateId,
    ...(emailAddresses.length > 0 && { 
      emailAddresses: emailAddresses,
    }),
  };
};